// ======================================================================
// File Name       : LiveReservedRegisterInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { LIVE_FORMAT_NUM } from '../../constants/UsageSettingLiveConstant';
import { LIVE_START_MIN_DATE } from '../../utils/index';
import RenderField from '../../utils/ReduxFormUtils';

class LiveReservedRegisterInfo extends React.Component {
  render() {
    const {
      invalid,
      publicStatus,
      showSelectOrganizerDialog,
      showSelectInviteesDialog,
      selectedUserId,
      storedUserList,
      enableReservingTimeTxt,
      reservingTimeTxt,
      enableReservingTime,
      reservingTime,
      isEdit,
      durationDetail,
      removeAllUserFromList,
      onewayLiveEntryLimit,
      twowayLiveEntryLimit,
      liveFormat,
      storedEdittingUserList,
    } = this.props;
    let organizerName = '';
    if (selectedUserId && storedUserList && storedUserList[selectedUserId]) {
      organizerName = storedUserList[selectedUserId].userName || '';
    }
    const maxDuration = isEdit
      ? Math.abs(enableReservingTime - reservingTime) + durationDetail
      : Math.abs(enableReservingTime - reservingTime);
    const selectedUsers = (storedEdittingUserList && Object.keys(storedEdittingUserList).length) || 0;
    const isDisableBtn =
    liveFormat === LIVE_FORMAT_NUM.ONE_WAY
      ? selectedUsers >= onewayLiveEntryLimit
      : selectedUsers >= twowayLiveEntryLimit;
    return (
      <Col sm={12}>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            ライブ名<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={5}>
            <RenderField
              type="text"
              name="liveName"
              label="ライブ名"
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>

        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            ライブ開催者<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={5}>
            <FormControlValidate type="text" name="organizerName" value={organizerName} disabled />
            <RenderField
              type="requiredarray"
              name="requiredOrganizer"
              label="ライブ開催者"
              validates={[VALIDATE_TYPE.REQUIRED_ARRAY]}
              keyArrayToCheck="selectedUserId"
            />
          </Col>
          <Col sm={3}>
            <Button
              variant="primary"
              className="btn-96 margin-left-10"
              onClick={showSelectOrganizerDialog}
            >
              ライブ開催者選択
            </Button>
          </Col>
        </Form.Group>

        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            実施日時<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={3}>
            <RenderField
              type="datetime"
              name="liveStartFrom"
              validates={[
                VALIDATE_TYPE.DATE_TIME_WITH_LIMIT,
                VALIDATE_TYPE.DATE_TIME,
                VALIDATE_TYPE.REQUIRED,
              ]}
              normalizeDateTime
              showTime
              label="開始日時"
              minDate={LIVE_START_MIN_DATE}
              shouldDisableDate
            />
          </Col>
          <Col sm={1} className="text-center" as={Form.Label}>
            ～
          </Col>
          <Col sm={3}>
            <RenderField
              type="datetime"
              name="liveStartTo"
              validates={[
                VALIDATE_TYPE.DATE_TIME_WITH_LIMIT,
                VALIDATE_TYPE.DATE_TIME,
                VALIDATE_TYPE.REQUIRED,
              ]}
              normalizeDateTime
              showTime
              label="終了日時"
              isDateTo
              minDate={LIVE_START_MIN_DATE}
              shouldDisableDate
            />
          </Col>
          <Col sm={12}>
            <RenderField
              name="dateTimeMinMax"
              type="dateTimeMinMax"
              validates={[
                VALIDATE_TYPE.SAME_MINUTE,
                VALIDATE_TYPE.SAME_DAY,
                VALIDATE_TYPE.MAX_DURATION,
              ]}
              maxDuration={maxDuration}
              keyDateFrom={'liveStartFrom'}
              keyDateTo={'liveStartTo'}
              label=""
            />
          </Col>
        </Form.Group>

        <Form.Group className="form-info">
          <Col sm={8} className="padding-left-clear">
            {enableReservingTimeTxt && (
              <Col sm={11}>
                <span>（予約可能時間　残</span>
                <span style={{ fontWeight: 'bold' }}> 
                  {enableReservingTimeTxt.h}
                </span>
                <span>時間</span>
                <span style={{ fontWeight: 'bold' }}>
                  {enableReservingTimeTxt.m}
                </span>
                <span>分　現在</span>
                <span style={{ fontWeight: 'bold' }}>{reservingTimeTxt.h}</span>
                <span>時間</span>
                <span style={{ fontWeight: 'bold' }}>{reservingTimeTxt.m}</span>
                <span>分予約済み）</span>
              </Col>
            )}
          </Col>
        </Form.Group>

        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            ライブ形式
          </Col>
          <Col sm={5}>
            <RenderField
              inline
              type="radio"
              name="liveFormat"
              value={LIVE_FORMAT_NUM.ONE_WAY}
              label="片方向"
              normalizeRadio
            />
            <RenderField
              inline
              type="radio"
              name="liveFormat"
              value={LIVE_FORMAT_NUM.TWO_WAY}
              label="双方向"
              normalizeRadio
            />
          </Col>
        </Form.Group>

        <Form.Group className="form-info padding-bottom-10">
          <Col as={Form.Label} sm={5}>
            <p>
              ライブに招待するユーザー<span className="required">&nbsp;(※)</span>
              （片方向 最大{onewayLiveEntryLimit}名 / 双方向 最大{twowayLiveEntryLimit}名）
            </p>
            <p className="padding-top-5">選択中ユーザー数：{selectedUsers} 名</p>
          </Col>
          <Col sm={3} className="form-label">
            <Button
              variant="primary"
              className="btn-96 margin-left-10"
              onClick={showSelectInviteesDialog}
              disabled={isDisableBtn}
            >
              追加
            </Button>
          </Col>
          <Col sm={4} className="text-right padding-top-10 padding-right-clear">
            <Button onClick={removeAllUserFromList}>ユーザー一括削除</Button>
          </Col>
        </Form.Group>

      </Col>
    );
  }
}

export default LiveReservedRegisterInfo;
